import { render, staticRenderFns } from "./AllocateCandidateAction.vue?vue&type=template&id=57baaacc&"
import script from "./AllocateCandidateAction.vue?vue&type=script&lang=js&"
export * from "./AllocateCandidateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports